import { render } from "./6_abastecimiento.vue?vue&type=template&id=211d9026&scoped=true"
import script from "./6_abastecimiento.vue?vue&type=script&lang=js"
export * from "./6_abastecimiento.vue?vue&type=script&lang=js"

import "./6_abastecimiento.vue?vue&type=style&index=0&id=211d9026&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211d9026"]])

export default __exports__